import React, {useEffect, useRef, useState} from "react";
import {getByIdResource, getResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import './ProfilePersonalInformationSegment.css'
import {DateLabelFormatter} from "../../ui/DateLabelFormatter";
import {GenericEditModalForm} from "./GenericEditModalForm";
import Plus from '../../../assets/img/profile-images/Plus-icon.png'
import {Link} from "react-router-dom";
import UploadImageModal from "../../ui/UploadImageModal";

export const ProfilePersonalInformationSegment = ({candidate, isPreview, setUpdateCandidate, updateCandidate}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [candidateDrivingLicencesList, setCandidateDrivingLicencesList] = useState([])

    const [entity, setEntity] = useState({candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)
    const [addImageEntity, setAddImageEntity] = useState(false)


    const getCandidateExistingDrivingLicencesList = () => {
        getByIdResource('candidate_driving_license/get_by_candidate', candidate.id).then(data => {
            setCandidateDrivingLicencesList(data.data);
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }


    const getCandidateExistingList = () => {
            setCandidateExistingList(candidate);
            if(candidate && candidate.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(candidate && candidate.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
        }
    }

    useEffect(()=> {
        getCandidateExistingList();
        getCandidateExistingDrivingLicencesList();
    },[])

    useEffect(() => {
        setUpdateCandidate(!updateEntity);
        getResource('candidates/get_logged_user_candidate').then(data => {
            setCandidateExistingList(data.data);

            getCandidateExistingDrivingLicencesList();
        })
    }, [updateEntity, addImageEntity])



    return(
        <div className='profile_segment_main_container'>
            {(candidateExistingList) &&
                <div className='profile_segment_separate_info'>
                   <div className="d-flex align-items-end">
                       <div className='candidate_image_container'>
                           {/*{(candidate && candidate.imageId) && <img src={`http://10.10.120.12:3000/data/rest/candidates/get_photo/${candidate.imageId}`}/>}*/}
                           {(candidateExistingList && candidateExistingList.imageId) &&
                               <img src={`https://apicareer.alkaloid.com.mk/data/rest/candidates/get_photo/${candidateExistingList.imageId}`}/>}
                       </div>
                       {(!isPreview && !addEntity) &&  <UploadImageModal
                           btnText={<img src={Plus}/>}
                           entity={entity} setEntity={setEntity}
                           addImageEntity={addImageEntity} setAddImageEntity={setAddImageEntity}
                           updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}
                           candidateImageId={candidateExistingList.imageId}
                       />}
                   </div>
                   <div className='personal_info_inner'>
                       <h5>Име:</h5>
                       <p>{candidateExistingList.firstName && candidateExistingList.firstName}</p>
                   </div>
                    <div className='personal_info_inner'>
                        <h5>Презиме:</h5>
                        <p>{candidateExistingList.lastName && candidateExistingList.lastName}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Корисничко име:</h5>
                        <p>{candidateExistingList.user && candidateExistingList.user.username}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>e-mail адреса:</h5>
                        <p>{candidateExistingList.email && candidateExistingList.email}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Датум на раѓање:</h5>
                        <p>{candidateExistingList.birthDate && <DateLabelFormatter dateString={candidateExistingList.birthDate}/>}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Телефон за контакт:</h5>
                        <p>{candidateExistingList.phone && candidateExistingList.phone}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Пол:</h5>
                        <p>{candidateExistingList.gender === true ? "Машки" : "Женски"}</p>
                    </div>
                    <div className='personal_info_inner'>
                        <h5>LinkedIn:</h5>
                        {(candidateExistingList.linkedIn && !candidateExistingList.linkedIn.includes('http')) ?
                            <a href={`https://${candidateExistingList.linkedIn}`}
                               target="_blank" rel="external">{candidateExistingList.linkedIn}</a>
                                : <a href={candidateExistingList.linkedIn} target="_blank" rel="external">
                                {candidateExistingList.linkedIn}</a>}
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Мајчин јазик:</h5>
                        {(candidateExistingList.nativeLanguage && candidateExistingList.nativeLanguage.name) &&
                            <p>{candidateExistingList.nativeLanguage.name}</p>}
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Општина на живеење:</h5>
                        {(candidateExistingList.placeOfLiving && candidateExistingList.placeOfLiving.name) &&
                            <p>{candidateExistingList.placeOfLiving.name}</p>}
                    </div>
                    <div className='personal_info_inner'>
                        <h5>Возачки дозволи:</h5>
                        {(candidateDrivingLicencesList && candidateDrivingLicencesList.length > 0) &&
                            candidateDrivingLicencesList.map(entity =>
                                <li key={entity.id}>{entity.drivingLicence && entity.drivingLicence.name} категорија</li>)}
                    </div>

                </div>}


            <div className='profile_footer_container'>
                <hr/>
                {(!isPreview && !addEntity) && (<div id="addPersonalInfo"
                    className="profile_add_button personal_info_button mt-3"
                    onClick={() => {setAddEntity(true)
                        setEntity({entity})
                    }}
                >Промени податоци</div>)}
                {addEntity === true && (<div className="open-form"> <GenericEditModalForm
                    type="PERSONAL_INFORMATION"
                    title= {"Промени податоци"}
                    entity={entity} setEntity={setEntity}
                    addEntity={addEntity} setAddEntity={setAddEntity}
                    updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}
                    setUpdateCandidate={setUpdateCandidate} updateCandidate={updateCandidate}
                /></div>)}
            </div>
        </div>
    )
}